var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaskCompleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    transform: "rotate(-90 8 8)",
    fill: "#0052D2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0855 5.22195C12.3159 5.47101 12.3159 5.87549 12.0855 6.12455L7.36699 11.2253C7.1366 11.4744 6.76243 11.4744 6.53204 11.2253L4.1728 8.67495C3.9424 8.42588 3.9424 8.02141 4.1728 7.77235C4.40319 7.52328 4.77735 7.52328 5.00775 7.77235L6.95044 9.87044L11.2524 5.22195C11.4828 4.97289 11.8569 4.97289 12.0873 5.22195L12.0855 5.22195Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskCompleteIcon);
export default __webpack_public_path__ + "static/media/TaskCompleteIcon.80fd4663b0998045c344f44fce2e493e.svg";
export { ForwardRef as ReactComponent };